import * as React from 'react'

import { ListItem } from '../../list'

interface IListItemRendererProps {
  children?: React.ReactNode
  displayBullets: boolean
  index: number
  listType: 'ordered' | 'unordered'
}

export default function ListItemRenderer({ children, displayBullets, index, listType }: IListItemRendererProps) {
  return (
    <ListItem displayBullets={displayBullets} index={index} listType={listType}>
      {children}
    </ListItem>
  )
}
